<template>
	<div>
    
		<div class="row mt-4">
			<div class="col-md-6">
        <Select2 id="dfe-filing-type" v-model="query.type" :options="filterTypes"/>
				<search-icon @click="find()" class="icon icon-within"/>
			</div>
			
			<div class="col-md-6">
				<button class="btn btn-outline px-3 mr-2"
								:class="{ 'btn-outline-active': showFilter }"
								@click="showFilter = !showFilter">
					Filtros
					<chevron-down-icon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
				</button>
				
				<button v-if="changeQuery" @click="find()" class="btn btn-link">
					Aplicar filtros ({{ numberOfBadges }})
				</button>
			</div>
		</div>
		
		<!-- Badge of filters -->
		<div class="row">
			<div class="col-md-12">
				<BadgeFilters :filters="[filterTypes, filterStartDate, filterEndDate]"
											:query="query"
											:amountChanged="updateNumberOfBadges"
											@clearAllBadges="$nextTick(() => find())"
											@clearBadge="$nextTick(() => find())"/>
			</div>
		</div>
		
		<div v-show="showFilter">
			
			<div class="row mt-4">
				<div class="col-md-4">
					<label for="dfe-filing-period-type">Tipo de período</label>
					<select id="dfe-filing-period-type" v-model="query.periodType" class="form-control">
            <option v-for="opt in filterPeriodType.table" :value="opt.value" :key="opt.value">
              {{ opt.label }}
            </option>
          </select>
				</div>
				
				<div class="col-md-4">
					<label for="alert-start-date">Data inicial</label>
					<input v-model="query.startDate" type="month" class="form-control" id="alert-start-date">
				</div>
				
				<div class="col-md-4">
					<label for="alert-end-date">Data final</label>
					<input v-model="query.endDate" type="month" class="form-control" id="alert-end-date">
				</div>
			
			</div>
		</div>
		
		<hr>
		<div class="row mt-4">
			<div class="col-md-6 mt-2">
				<strong>{{ infoTotalModels }}</strong>
			</div>
		</div>
		
		<div class="row mt-2">
			<div class="col-md-12">
				
				<table class="table table-borderless table-dfe">
					<thead>
						<tr>
							<th>Período</th>
							<th>Tipo</th>
							<th>Quantidade</th>
							<th>Tamanho</th>
							<th>Criado em</th>
              <th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="filing in filings" :key="filing.id">
							<td>{{ filing.period | period }}</td>
							<td>{{ filing.filingType }}</td>
							<td>{{ filing.amount }}</td>
							<td>{{ filing.size | sizeBytes }}</td>
							<td>{{ filing.createdAt | datetime }}</td>
              <td>
                <DownloadCloudIcon @click="download(filing)" style="cursor: pointer" size="2x" class="custom-class"/>
              </td>
						</tr>
					</tbody>
				</table>
				
				<div class="row">
					<div class="col-md-12 my-1">
						<Pagination
              v-model="meta.currentPage"
              :total-count="meta.totalCount"
              :total-pages="meta.totalPages"
              @pagination="pagination"
            />
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Pagination from '@/components/shares/specialTag/Pagination'
	import BadgeFilters from '@/components/shares/BadgeFilters'
	import ModelMapper from '@/mixins/ModelMapper'
	import Select2 from '@/components/shares/Select2'
	
	import { ChevronDownIcon, DownloadCloudIcon, SearchIcon } from 'vue-feather-icons'
	import { Filter } from '@/models/filter'
	
	export default {
		components: { BadgeFilters, ChevronDownIcon, DownloadCloudIcon, Pagination, SearchIcon, Select2 },
		computed: {
			filings() {
				return this.getModels || []
			}
		},
		created() {
			this.defaultModelSetting.updateQueryURL = true
			this.addOrderBy('period')
			this.addOrderBy('type')
      this.$set(this.query, 'periodType', 'period')
			
			this.asyncTemplateSelect({
				after: () => this.loadFilterTypes(),
				byURL: true,
				pagination: true
			})
		},
		data() {
			return {
				filterEndDate: new Filter({
					key: 'endDate',
					label: 'Data final',
					type: 'date'
				}),
				filterPeriodType: new Filter({
          key: 'periodType',
          label: 'Tipo do período',
          table: [['Período', 'period'], ['Inclusão', 'created_at']],
          valueFormatter: value =>  {
            if (value === 'created_at') return 'Inclusão'
          }
        }),
				filterStartDate: new Filter({
					key: 'startDate',
					label: 'Data inicial',
					type: 'date'
				}),
				filterTypes: null,
        nameModel: 'Filing',
				showModal: false,
			}
		},
    filters: {
      period(string) {
        return string.split('-').reverse().join('/')
      },
      sizeBytes(size) {
        let i = Math.floor( Math.log(size) / Math.log(1024) );
        return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
      }
    },
    methods: {
      download(filing) {
        this.openLoad()
        this.axios.get(`/filings/${filing.id}/download`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`${filing.filingType} ${filing.period}.zip`, blob))
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeLoad())
      },
			find() {
				this.asyncTemplateSelect()
			},
			async loadFilterTypes() {
				const keyLocalStorage = 'lastFilterFilingTypes'
				const label = 'Tipo'
				const key = 'type'
				
				let options = this.$ls.get(keyLocalStorage)
				if (options)
					this.filterTypes = new Filter({ key, label, table: options })
				
				let response = await this.axios.get('/filings/types')
				options = response.data
				
				this.filterTypes = new Filter({key, label, table: options})
				this.$ls.set(keyLocalStorage, options, { minutes: 5 })
			}
		},
		mixins: [ModelMapper],
		name: 'Filing'
	}
</script>

<style scoped>
  .icon-within {
    top: 5px;
  }
</style>